/**
 * Created by eriksundqvist on 17/10/16.
 */

import moment from 'moment';
import _ from 'lodash';
import Utils from 'frilans-finans/utils/utils';

class WorkDateHelper {

  formatDisplayDate (startDate, endDate) {
    let displayDate = Utils.formatDate(startDate);
    if (+startDate !== +endDate) {
      displayDate += ' — ' + Utils.formatDate(endDate);
    }

    return displayDate;
  }

  parseWorkDates (workDates) {
    let selectedDays = [];
    let newSelectedDays = true;
    let currentStartDate;

    workDates = _.orderBy(workDates, 'date', 'asc');

    for (let i = 0; i < workDates.length; i++) {
      if (newSelectedDays) {
        currentStartDate = workDates[i].date;
      }
      let thisDate = workDates[i].date;

      let nextDate = (workDates[i + 1]) ? workDates[i + 1].date : null;
      nextDate = (nextDate) ? moment(nextDate).clone().subtract(1, 'day') : null;

      if (newSelectedDays) {
        let startDate = moment(currentStartDate).toDate();
        let endDate = moment(thisDate).toDate();

        selectedDays.push({
          startDate: startDate,
          endDate: endDate,
          workHours: workDates[i].hours,
          startDateString: thisDate.replace(/-/g, '')
        });
      } else {
        selectedDays[selectedDays.length - 1].endDate = moment(thisDate).toDate();
      }

      if (!nextDate) {
        break;
      }

      newSelectedDays = true;
    }

    for (let i = 0; i<selectedDays.length; i++) {
      selectedDays[i].displayDate = this.formatDisplayDate(selectedDays[i].startDate, selectedDays[i].endDate);

      let daysDiff = moment.duration(
          moment(selectedDays[i].endDate).diff(selectedDays[i].startDate)
        ).days() + 1;

      selectedDays[i].totalHoursForPeriod = daysDiff * selectedDays[i].workHours;
    }

    return _.orderBy(selectedDays, 'startDateString', 'asc');
  }
}

export default new WorkDateHelper();



/** WEBPACK FOOTER **
 ** ./src/views/invoice-tool/work-date/work-date-helper.js
 **/